import { render } from "./TheDeviceMessages.vue?vue&type=template&id=0cb1a576"
import script from "./TheDeviceMessages.vue?vue&type=script&lang=js"
export * from "./TheDeviceMessages.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__